var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _rect, _rect2, _g1, _path33, _rect3, _rect4, _g10, _path34, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566,
    height: 265,
    viewBox: "0 0 566 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 443.5,
    cy: 122.5,
    r: 122.5,
    fill: "#F3E4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.482 64.1941L494.997 64.6624L516.149 59.7444L529.31 69.8144L527.9 74.9663L531.19 76.1374L539.415 96.7457L548.816 96.9802L556.806 109.392L531.895 115.949L530.955 123.677L525.315 119.227L510.744 147.563L479.722 145.221L483.482 64.1935L483.482 64.1941Z",
    fill: "white",
    stroke: "#E7E5E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.357 128.126L498.053 133.044L501.108 142.412L504.163 144.754L513.329 143.349L516.384 146.159L511.918 156.698L493.587 178.477L495.233 193.933L463.741 191.123L460.45 125.552L489.357 128.127V128.126Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.059 63.2576L451.99 71.2199L467.03 76.6063L468.91 70.9861L483.716 64.4286L488.887 72.391V80.5872L479.016 117.354L454.574 120.633L425.198 94.1697L428.018 70.5172L443.059 63.2576H443.059Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.914 41.2443L373.729 32.1109L400.286 28.13L428.253 33.5164L430.133 50.1433L434.363 53.1875L425.433 93.7014L348.583 85.9735L366.914 41.2443Z",
    fill: "white",
    stroke: "#E7E5E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.032 77.3084L420.263 75.9035L421.202 73.5614L420.732 72.6248L432.013 51.5482L439.769 55.529L443.294 63.2569L438.828 68.175L442.589 73.3269L439.064 82.2259L445.174 113.373L408.041 113.841L401.226 84.8018L416.032 77.3078L416.032 77.3084Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.232 202.363L348.818 210.559V218.755L351.873 217.818L358.688 229.762L354.928 235.616L360.568 239.597L366.913 232.338L385.244 246.388L414.151 208.451L379.134 187.374L346.231 202.361L346.232 202.363Z",
    fill: "white",
    stroke: "#E7E5E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.868 201.192L348.348 209.622L344.588 210.793L334.482 217.819L327.666 235.149L320.381 240.769L318.501 239.364L317.091 227.186L323.201 214.775L326.022 211.731L322.731 204.471H320.381L311.92 194.635L321.321 171.686L345.057 174.028L355.868 201.193L355.868 201.192Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.863 170.279L477.489 187.141L483.365 185.736L494.998 190.068L496.173 197.211L492.648 199.436L487.948 225.196L483.012 225.547L481.719 233.627L471.026 241.589L474.081 252.947L456.572 256.576L451.402 250.371L445.174 256.576L437.419 231.051L392.766 174.261L459.863 170.28L459.863 170.279Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M408.489 184.225L417.377 197.186L418.894 196.322L424.964 204.314V210.362L428.433 208.202L434.286 221.163L437.104 223.972L439.705 236.933L431.034 232.181L421.929 237.149L421.712 240.605L408.272 244.061L407.839 247.517L396.566 262.422L389.629 257.022L383.125 254.861L381.391 243.845L386.594 241.468L385.293 231.1L396.783 226.78L384.643 185.952L401.986 179.256L408.489 184.224V184.225Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M458.762 112.706L466.806 108.347L470.475 110.035L482.046 97.6612L481.199 86.6936L489.101 77.6947L489.806 85.1471L489.383 92.7399L487.69 95.271L493.757 99.0673L500.954 97.9424L504.199 104.973L495.591 119.174L493.475 130.423L483.457 127.61L468.748 131.6L458.763 112.706H458.762Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.718 107.504L443.099 104.551L451.848 105.114L450.437 100.755L452.835 100.333L459.326 105.817L462.43 119.737L469.627 122.549L475.13 133.095L451.848 145.75L419.816 124.237L427.718 107.504V107.504Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.191 172.886L449.59 170.496L460.314 181.182L466.24 176.261L464.829 174.574L468.78 170.215L468.498 163.184L466.1 161.357L466.523 155.733L472.449 151.795L476.259 151.936L480.21 148.421L479.645 128.735L469.063 130.563L463.136 137.593L444.51 139.421L433.927 130.985L425.038 147.295L447.192 172.886L447.191 172.886Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.434 111.301L429.134 118.559L432.227 122.735L432.726 126.91L436.518 128.6L438.613 134.665L436.518 134.764L434.423 137.846L435.72 142.42L434.622 146.098L406.885 146.595L405.587 115.973L429.434 111.3V111.301Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.583 128.402L409.379 119.454L419.357 117.863L426.84 112.096L429.235 111.301L429.335 107.224L425.144 102.949L419.157 102.452L407.184 89.4272L389.124 92.1114L393.814 121.64L407.583 128.402V128.402Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.442 95.271L408.669 111.722L405.282 112.706L404.577 116.362L401.473 119.596L406.694 127.751L386.656 134.219L379.742 95.4113L392.442 95.271Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.264 128.876L401.049 125.502L404.154 127.47L406.27 126.205L407.964 126.065L409.798 131.126L406.411 136.891L396.251 136.048L395.264 128.876Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.594 178.23L344.607 182.448L348.558 195.384L346.724 200.165L358.577 209.585L362.528 204.945L368.878 206.07L374.381 201.43L378.05 203.82L389.339 202.695L391.879 197.352L385.812 171.762L355.332 170.637L345.596 178.23H345.594Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.54 179.776L419.534 182.87L425.32 181.042L430.258 183.713L428.706 185.822L433.222 188.353L446.344 178.792L450.154 181.604L451.565 176.262L448.038 173.871L448.179 171.34L440.277 160.935L440.418 156.717L443.522 153.061L431.669 154.326L428.141 146.452L419.393 139.562L412.055 144.342L407.54 179.775V179.776Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.663 134.5L402.601 133.938L407.258 135.063L413.326 137.875L420.24 132.954L424.897 135.625V143.078L417.7 144.203L417.841 154.748L421.51 164.45L419.252 167.121L415.583 166.84L412.62 176.26L409.797 178.229L408.669 184.556L393.147 162.903L397.662 134.5L397.663 134.5Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.678 74.7126L415.664 74.6133L418.657 76.3033L415.764 83.561L414.766 90.0236L411.872 94.1992L401.097 95.5913L397.804 100.861L392.415 95.5913L366.872 102.551L364.677 74.712L364.678 74.7126Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.933 185.273L382.638 188.753L390.82 190.94L396.008 183.383L408.68 184.776L399.5 166.283L403.691 160.416L402.494 156.439L396.906 147.79L399.001 143.216L396.606 140.83L397.904 134.466L385.731 133.074L379.246 158.03L384.933 185.272L384.933 185.273Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.851 156.838L345.62 178.512L355 175.231L359.39 176.324L367.073 172.944L367.671 179.208L369.967 178.412L370.465 182.489L378.747 185.471L379.445 184.378L385.032 185.67L387.227 183.483L387.527 172.944L382.039 159.323L388.125 153.656L389.322 147.194L364.578 141.228L331.851 156.838H331.851Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.279 146.487L389.338 147.437L392.865 134.22L397.009 134.278L396.261 127.922L379.991 113.443L351.239 113.41L372.279 146.487Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.594 96.8181L383.975 97.8021L384.54 105.676L392.159 116.221L396.393 128.454L390.467 130.704L383.834 126.486L380.165 117.768L368.594 117.065L364.643 119.455L352.226 104.129L368.594 96.8174L368.594 96.8181Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.005 61.9475L339.95 58.1511L343.055 49.1522L349.122 48.871L359.423 42.5435L367.749 40.8561V45.3552L378.19 48.1676L379.037 54.0729L387.645 62.7905L381.719 72.0707L383.694 75.3046L381.296 82.3348L378.473 78.6787L376.639 82.3348L376.78 88.5213L373.393 95.2703L362.669 106.378H347.288L324.006 61.9462L324.005 61.9475Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.589 118.612L358.153 125.08L363.374 126.486L370.712 140.125H375.368L378.473 137.172L380.589 147.015L362.387 154.749L349.264 126.908L357.589 118.612H357.589Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.601 155.311L362.951 160.794L370.43 159.529L371.417 152.639L357.447 138.719L353.92 128.174L355.19 115.941L332.895 117.206L346.865 152.639L356.601 155.311Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.87 77.2732L344.466 90.49L342.772 93.4426L345.03 100.192L346.3 97.9417L350.11 98.7855L365.914 118.611L364.502 122.407L358.999 120.439L357.447 122.689L345.03 121.564L337.269 126.906L307.777 118.189L311.446 82.1932L334.87 77.2719L334.87 77.2732Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.496 108.941L307.936 106.419L313.946 108.941L316.477 101.691L316.866 95.353L324.317 90.0281L331.978 90.6585L329.447 85.2996L337.989 81.5167L323.753 61.6573L318.691 59.1351L313.946 64.8092L286.424 75.842L297.496 108.941H297.496Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.667 185.26L296.207 192.853L306.225 193.978L319.208 204.101L323.441 201.992L325.84 185.822L322.594 181.464L325.417 178.932L334.306 185.119L348.981 173.73L343.055 165.996L344.748 160.512L351.662 160.653L352.368 156.154L356.883 155.591L352.791 147.576L345.171 144.764L295.22 150.669L293.668 185.259L293.667 185.26Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.821 167.262L272.361 178.37L279.84 183.15L284.778 181.463L289.717 186.243L297.478 186.384L296.349 181.322L303.122 175.417L295.643 172.323L298.466 166.418L303.404 165.012L315.681 165.855L329.086 148.701H334.024L338.822 155.872L344.466 155.451L345.03 150.108L348.135 147.155V142.094L338.117 135.345L272.925 136.188L269.821 167.263V167.262Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.379 159.131L273.993 169.188L285.557 157.486L282.709 151.812L285.873 141.094L289.353 140.149L298.211 123.127L282.71 119.029L290.619 115.561L290.303 113.039L297.578 109.256L285.874 74.5807L271.638 71.7433L267.842 75.211L253.922 65.4389L252.973 83.092L261.515 109.571L255.825 119.309L259.622 138.402L252.38 159.13L252.379 159.131Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.434 140.406L296.631 142.656L299.03 141.531L302.699 144.906L308.625 140.829L311.165 143.219L325.981 142.516L329.086 139.422L333.037 139.282L337.411 142.657L343.055 142.376L344.184 138.579L346.442 136.47L344.749 126.065L346.442 121.144L341.645 118.754L338.117 122.831H332.896V118.051L326.264 121.285L322.595 113.27L313.847 108.771L308.061 106.24L297.76 108.911L290.705 112.989L290.564 115.239L282.945 119.176L297.902 122.972L289.436 140.408L289.434 140.406Z",
    fill: "white",
    stroke: "#E7E5E9",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M254.575 65.8937L267.997 76.147L272.471 72.1347L287.234 75.7011L313.182 65.8937L318.551 59.2069L323.92 61.8815L340.026 57.8692L342.71 48.953L349.868 48.5071L359.71 42.2661L367.316 40.9285L374.026 31.5664L399.975 28L428.607 33.3499L429.95 50.2906L439.792 55.6405L443.371 63.2191L452.319 71.2436L467.53 76.5935L468.872 70.7984L483.188 64.5574H495.715L516.295 60.0993L529.716 70.3525L527.48 75.7024L531.506 76.5941L539.559 97.1012L548.507 96.6554L557.008 109.584L531.969 116.435L531.336 124.946L525.325 119.272L512.988 143.86L515.836 146.382L511.407 157.73L493.375 178.535L496.222 197.449L492.742 199.34L487.997 225.504L482.619 225.819L481.986 233.7L470.914 241.896L474.394 253.56L456.678 257.027L451.617 250.723L444.974 257.658L439.596 237.798L430.738 232.124L421.88 237.483L421.564 240.636L408.277 244.419L407.961 248.201L396.256 263.017L388.663 256.713L382.653 254.507L381.388 243.474L367.152 231.81L360.825 240.007L354.498 235.908L358.611 229.604L351.652 217.941L348.488 219.202V209.114L344.059 210.69L335.201 217.625L327.925 235.278L320.333 240.952L318.2 238.798L317.169 227.713L323.179 214.788L326.027 211.951L322.547 204.701L319.699 204.386L306.413 193.983L295.973 193.038L294.075 186.733H289.963L285.217 181.374L280.156 183.266L272.563 179.167L270.032 167.819L252 159.308L259.593 138.503L255.48 119.274L261.491 109.187L254.215 82.0773L254.576 65.8982L254.575 65.8937Z",
    stroke: "#4A4A68",
    strokeWidth: 3.1,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.827 118H300.984C298.238 118 296.01 120.228 296 122.974V142.759C296 145.505 298.228 147.733 300.974 147.743H309.061L314.055 155.552C314.234 155.84 314.552 156.01 314.89 156C315.229 156 315.547 155.83 315.726 155.542L320.67 147.743H328.827C331.572 147.733 333.801 145.505 333.801 142.759V122.974C333.791 120.228 331.572 118 328.827 118Z",
    fill: "#4A4A68"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.75 132.5C321.75 137.75 315 142.25 315 142.25C315 142.25 308.25 137.75 308.25 132.5C308.25 130.71 308.961 128.993 310.227 127.727C311.493 126.461 313.21 125.75 315 125.75C316.79 125.75 318.507 126.461 319.773 127.727C321.039 128.993 321.75 130.71 321.75 132.5Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 134.75C316.243 134.75 317.25 133.743 317.25 132.5C317.25 131.257 316.243 130.25 315 130.25C313.757 130.25 312.75 131.257 312.75 132.5C312.75 133.743 313.757 134.75 315 134.75Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.827 18H401.984C399.238 18 397.01 20.2282 397 22.9738V42.7594C397 45.5049 399.228 47.7332 401.974 47.7431H410.061L415.055 55.552C415.234 55.8404 415.552 56.0096 415.89 55.9996C416.229 55.9996 416.547 55.8305 416.726 55.542L421.67 47.7431H429.827C432.572 47.7332 434.801 45.5049 434.801 42.7594V22.9738C434.791 20.2282 432.572 18 429.827 18Z",
    fill: "#4A4A68"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.75 32.5C422.75 37.75 416 42.25 416 42.25C416 42.25 409.25 37.75 409.25 32.5C409.25 30.7098 409.961 28.9929 411.227 27.727C412.493 26.4612 414.21 25.75 416 25.75C417.79 25.75 419.507 26.4612 420.773 27.727C422.039 28.9929 422.75 30.7098 422.75 32.5Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 34.75C417.243 34.75 418.25 33.7426 418.25 32.5C418.25 31.2574 417.243 30.25 416 30.25C414.757 30.25 413.75 31.2574 413.75 32.5C413.75 33.7426 414.757 34.75 416 34.75Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.827 92H400.984C398.238 92 396.01 94.2282 396 96.9738V116.759C396 119.505 398.228 121.733 400.974 121.743H409.061L414.055 129.552C414.234 129.84 414.552 130.01 414.89 130C415.229 130 415.547 129.83 415.726 129.542L420.67 121.743H428.827C431.572 121.733 433.801 119.505 433.801 116.759V96.9738C433.791 94.2282 431.572 92 428.827 92Z",
    fill: "#4A4A68"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.75 106.5C421.75 111.75 415 116.25 415 116.25C415 116.25 408.25 111.75 408.25 106.5C408.25 104.71 408.961 102.993 410.227 101.727C411.493 100.461 413.21 99.75 415 99.75C416.79 99.75 418.507 100.461 419.773 101.727C421.039 102.993 421.75 104.71 421.75 106.5Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 108.75C416.243 108.75 417.25 107.743 417.25 106.5C417.25 105.257 416.243 104.25 415 104.25C413.757 104.25 412.75 105.257 412.75 106.5C412.75 107.743 413.757 108.75 415 108.75Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.827 100H474.984C472.238 100 470.01 102.228 470 104.974V124.759C470 127.505 472.228 129.733 474.974 129.743H483.061L488.055 137.552C488.234 137.84 488.552 138.01 488.89 138C489.229 138 489.547 137.83 489.726 137.542L494.67 129.743H502.827C505.572 129.733 507.801 127.505 507.801 124.759V104.974C507.791 102.228 505.572 100 502.827 100Z",
    fill: "#4A4A68"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.75 114.5C495.75 119.75 489 124.25 489 124.25C489 124.25 482.25 119.75 482.25 114.5C482.25 112.71 482.961 110.993 484.227 109.727C485.493 108.461 487.21 107.75 489 107.75C490.79 107.75 492.507 108.461 493.773 109.727C495.039 110.993 495.75 112.71 495.75 114.5Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 116.75C490.243 116.75 491.25 115.743 491.25 114.5C491.25 113.257 490.243 112.25 489 112.25C487.757 112.25 486.75 113.257 486.75 114.5C486.75 115.743 487.757 116.75 489 116.75Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.827 199H438.984C436.238 199 434.01 201.228 434 203.974V223.759C434 226.505 436.228 228.733 438.974 228.743H447.061L452.055 236.552C452.234 236.84 452.552 237.01 452.89 237C453.229 237 453.547 236.83 453.726 236.542L458.67 228.743H466.827C469.572 228.733 471.801 226.505 471.801 223.759V203.974C471.791 201.228 469.572 199 466.827 199Z",
    fill: "#4A4A68"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.75 213.5C459.75 218.75 453 223.25 453 223.25C453 223.25 446.25 218.75 446.25 213.5C446.25 211.71 446.961 209.993 448.227 208.727C449.493 207.461 451.21 206.75 453 206.75C454.79 206.75 456.507 207.461 457.773 208.727C459.039 209.993 459.75 211.71 459.75 213.5Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 215.75C454.243 215.75 455.25 214.743 455.25 213.5C455.25 212.257 454.243 211.25 453 211.25C451.757 211.25 450.75 212.257 450.75 213.5C450.75 214.743 451.757 215.75 453 215.75Z",
    stroke: "#D092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 8,
    y: 75,
    width: 235,
    height: 52,
    rx: 4,
    fill: "#D092DD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 67,
    width: 233,
    height: 50,
    rx: 3,
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 92C27 86.4772 31.4772 82 37 82H57C62.5228 82 67 86.4772 67 92C67 97.5228 62.5228 102 57 102H37C31.4772 102 27 97.5228 27 92Z",
    fill: "#4A4A68"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 92,
    r: 7,
    fill: "white"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M82.04 97.144C81.1547 97.144 80.3547 97.032 79.64 96.808C78.9253 96.5733 78.3067 96.2373 77.784 95.8L78.248 94.744C78.792 95.16 79.3627 95.4693 79.96 95.672C80.5573 95.8747 81.2507 95.976 82.04 95.976C83 95.976 83.7093 95.8 84.168 95.448C84.6373 95.0853 84.872 94.6107 84.872 94.024C84.872 93.5547 84.7013 93.1813 84.36 92.904C84.0293 92.6267 83.4693 92.408 82.68 92.248L81.016 91.912C80.0133 91.6987 79.2613 91.352 78.76 90.872C78.2693 90.3813 78.024 89.7307 78.024 88.92C78.024 88.248 78.1947 87.6613 78.536 87.16C78.888 86.6587 79.3733 86.2693 79.992 85.992C80.6107 85.7147 81.3253 85.576 82.136 85.576C82.8933 85.576 83.5973 85.6987 84.248 85.944C84.8987 86.1787 85.448 86.52 85.896 86.968L85.432 87.992C84.952 87.5547 84.4453 87.24 83.912 87.048C83.3787 86.8453 82.7813 86.744 82.12 86.744C81.2773 86.744 80.6053 86.9413 80.104 87.336C79.6027 87.72 79.352 88.232 79.352 88.872C79.352 89.384 79.5067 89.7893 79.816 90.088C80.136 90.3867 80.6533 90.6053 81.368 90.744L83.032 91.096C84.1093 91.32 84.904 91.6613 85.416 92.12C85.9387 92.568 86.2 93.1813 86.2 93.96C86.2 94.5893 86.0293 95.144 85.688 95.624C85.3573 96.104 84.8773 96.4773 84.248 96.744C83.6293 97.0107 82.8933 97.144 82.04 97.144ZM90.5078 97.144C89.9744 97.144 89.4944 97.0427 89.0678 96.84C88.6518 96.6267 88.3211 96.3387 88.0758 95.976C87.8304 95.6133 87.7078 95.208 87.7078 94.76C87.7078 94.1947 87.8518 93.7467 88.1398 93.416C88.4384 93.0853 88.9238 92.8507 89.5958 92.712C90.2784 92.5627 91.2064 92.488 92.3798 92.488H92.8918V91.992C92.8918 91.3307 92.7531 90.856 92.4758 90.568C92.2091 90.2693 91.7771 90.12 91.1798 90.12C90.7104 90.12 90.2571 90.1893 89.8198 90.328C89.3824 90.456 88.9344 90.6693 88.4758 90.968L88.0278 90.024C88.4331 89.736 88.9238 89.5067 89.4998 89.336C90.0864 89.1653 90.6464 89.08 91.1798 89.08C92.1824 89.08 92.9238 89.3253 93.4038 89.816C93.8944 90.3067 94.1398 91.0693 94.1398 92.104V97H92.9238V95.656C92.7211 96.1147 92.4064 96.4773 91.9798 96.744C91.5638 97.0107 91.0731 97.144 90.5078 97.144ZM90.7158 96.168C91.3558 96.168 91.8784 95.9493 92.2838 95.512C92.6891 95.064 92.8918 94.4987 92.8918 93.816V93.336H92.3958C91.5318 93.336 90.8491 93.3787 90.3478 93.464C89.8571 93.5387 89.5104 93.6773 89.3078 93.88C89.1158 94.072 89.0198 94.3387 89.0198 94.68C89.0198 95.1173 89.1691 95.4747 89.4678 95.752C89.7771 96.0293 90.1931 96.168 90.7158 96.168ZM96.5761 97V89.224H97.8401V90.536C98.0748 90.0667 98.4001 89.7093 98.8161 89.464C99.2321 89.208 99.7175 89.08 100.272 89.08C101.488 89.08 102.267 89.608 102.608 90.664C102.843 90.1733 103.189 89.7893 103.648 89.512C104.107 89.224 104.635 89.08 105.232 89.08C106.96 89.08 107.824 90.104 107.824 92.152V97H106.528V92.216C106.528 91.5013 106.4 90.9787 106.144 90.648C105.899 90.3067 105.488 90.136 104.912 90.136C104.283 90.136 103.781 90.36 103.408 90.808C103.035 91.256 102.848 91.8533 102.848 92.6V97H101.552V92.216C101.552 91.5013 101.424 90.9787 101.168 90.648C100.923 90.3067 100.512 90.136 99.9361 90.136C99.2961 90.136 98.7895 90.36 98.4161 90.808C98.0535 91.256 97.8721 91.8533 97.8721 92.6V97H96.5761ZM113.751 97.144C112.525 97.144 111.554 96.7867 110.839 96.072C110.125 95.3467 109.767 94.3653 109.767 93.128C109.767 92.328 109.927 91.624 110.247 91.016C110.567 90.3973 111.005 89.9227 111.559 89.592C112.125 89.2507 112.775 89.08 113.511 89.08C114.567 89.08 115.394 89.4213 115.991 90.104C116.589 90.776 116.887 91.704 116.887 92.888V93.384H111.031C111.074 94.2693 111.33 94.9467 111.799 95.416C112.269 95.8747 112.919 96.104 113.751 96.104C114.221 96.104 114.669 96.0347 115.095 95.896C115.522 95.7467 115.927 95.5067 116.311 95.176L116.759 96.088C116.407 96.4187 115.959 96.68 115.415 96.872C114.871 97.0533 114.317 97.144 113.751 97.144ZM113.543 90.04C112.807 90.04 112.226 90.2693 111.799 90.728C111.373 91.1867 111.122 91.7893 111.047 92.536H115.767C115.735 91.7467 115.527 91.1333 115.143 90.696C114.77 90.2587 114.237 90.04 113.543 90.04ZM118.871 93.272V92.2H123.351V93.272H118.871ZM125.892 97V85.72H129.7C131.524 85.72 132.932 86.2053 133.924 87.176C134.916 88.136 135.412 89.528 135.412 91.352C135.412 93.176 134.916 94.5733 133.924 95.544C132.932 96.5147 131.524 97 129.7 97H125.892ZM127.204 95.88H129.604C132.548 95.88 134.02 94.3707 134.02 91.352C134.02 88.344 132.548 86.84 129.604 86.84H127.204V95.88ZM140.039 97.144C139.506 97.144 139.026 97.0427 138.599 96.84C138.183 96.6267 137.852 96.3387 137.607 95.976C137.362 95.6133 137.239 95.208 137.239 94.76C137.239 94.1947 137.383 93.7467 137.671 93.416C137.97 93.0853 138.455 92.8507 139.127 92.712C139.81 92.5627 140.738 92.488 141.911 92.488H142.423V91.992C142.423 91.3307 142.284 90.856 142.007 90.568C141.74 90.2693 141.308 90.12 140.711 90.12C140.242 90.12 139.788 90.1893 139.351 90.328C138.914 90.456 138.466 90.6693 138.007 90.968L137.559 90.024C137.964 89.736 138.455 89.5067 139.031 89.336C139.618 89.1653 140.178 89.08 140.711 89.08C141.714 89.08 142.455 89.3253 142.935 89.816C143.426 90.3067 143.671 91.0693 143.671 92.104V97H142.455V95.656C142.252 96.1147 141.938 96.4773 141.511 96.744C141.095 97.0107 140.604 97.144 140.039 97.144ZM140.247 96.168C140.887 96.168 141.41 95.9493 141.815 95.512C142.22 95.064 142.423 94.4987 142.423 93.816V93.336H141.927C141.063 93.336 140.38 93.3787 139.879 93.464C139.388 93.5387 139.042 93.6773 138.839 93.88C138.647 94.072 138.551 94.3387 138.551 94.68C138.551 95.1173 138.7 95.4747 138.999 95.752C139.308 96.0293 139.724 96.168 140.247 96.168ZM146.893 99.88L148.221 96.872L144.941 89.224H146.349L148.925 95.528L151.517 89.224H152.877L148.253 99.88H146.893ZM163.237 97.144C162.192 97.144 161.28 96.9093 160.501 96.44C159.733 95.96 159.136 95.288 158.709 94.424C158.293 93.56 158.085 92.536 158.085 91.352C158.085 90.168 158.293 89.144 158.709 88.28C159.125 87.416 159.717 86.7493 160.485 86.28C161.264 85.8107 162.181 85.576 163.237 85.576C164.304 85.576 165.221 85.8107 165.989 86.28C166.768 86.7493 167.365 87.416 167.781 88.28C168.208 89.1333 168.421 90.152 168.421 91.336C168.421 92.52 168.208 93.5493 167.781 94.424C167.355 95.288 166.752 95.96 165.973 96.44C165.205 96.9093 164.293 97.144 163.237 97.144ZM163.237 95.976C164.443 95.976 165.376 95.5707 166.037 94.76C166.699 93.9493 167.029 92.8133 167.029 91.352C167.029 89.8907 166.699 88.76 166.037 87.96C165.376 87.1493 164.443 86.744 163.237 86.744C162.053 86.744 161.131 87.1493 160.469 87.96C159.808 88.76 159.477 89.8907 159.477 91.352C159.477 92.8027 159.808 93.9387 160.469 94.76C161.131 95.5707 162.053 95.976 163.237 95.976ZM170.591 97V89.224H171.855V90.616C172.271 89.6773 173.124 89.16 174.415 89.064L174.879 89.016L174.975 90.136L174.159 90.232C173.423 90.296 172.863 90.5307 172.479 90.936C172.095 91.3307 171.903 91.8747 171.903 92.568V97H170.591ZM179.192 97.144C178.498 97.144 177.89 96.9787 177.368 96.648C176.856 96.3173 176.456 95.8533 176.168 95.256C175.89 94.648 175.752 93.9333 175.752 93.112C175.752 92.28 175.89 91.5653 176.168 90.968C176.456 90.36 176.856 89.896 177.368 89.576C177.89 89.2453 178.498 89.08 179.192 89.08C179.8 89.08 180.333 89.2133 180.792 89.48C181.261 89.7467 181.608 90.1147 181.832 90.584V85.72H183.128V97H181.864V95.576C181.64 96.0667 181.293 96.4507 180.824 96.728C180.354 97.0053 179.81 97.144 179.192 97.144ZM179.464 96.104C180.189 96.104 180.77 95.848 181.208 95.336C181.645 94.8133 181.864 94.072 181.864 93.112C181.864 92.1413 181.645 91.4 181.208 90.888C180.77 90.376 180.189 90.12 179.464 90.12C178.728 90.12 178.141 90.376 177.704 90.888C177.277 91.4 177.064 92.1413 177.064 93.112C177.064 94.072 177.277 94.8133 177.704 95.336C178.141 95.848 178.728 96.104 179.464 96.104ZM189.064 97.144C187.837 97.144 186.866 96.7867 186.152 96.072C185.437 95.3467 185.08 94.3653 185.08 93.128C185.08 92.328 185.24 91.624 185.56 91.016C185.88 90.3973 186.317 89.9227 186.872 89.592C187.437 89.2507 188.088 89.08 188.824 89.08C189.88 89.08 190.706 89.4213 191.304 90.104C191.901 90.776 192.2 91.704 192.2 92.888V93.384H186.344C186.386 94.2693 186.642 94.9467 187.112 95.416C187.581 95.8747 188.232 96.104 189.064 96.104C189.533 96.104 189.981 96.0347 190.408 95.896C190.834 95.7467 191.24 95.5067 191.624 95.176L192.072 96.088C191.72 96.4187 191.272 96.68 190.728 96.872C190.184 97.0533 189.629 97.144 189.064 97.144ZM188.856 90.04C188.12 90.04 187.538 90.2693 187.112 90.728C186.685 91.1867 186.434 91.7893 186.36 92.536H191.08C191.048 91.7467 190.84 91.1333 190.456 90.696C190.082 90.2587 189.549 90.04 188.856 90.04ZM194.075 97V89.224H195.339V90.616C195.755 89.6773 196.609 89.16 197.899 89.064L198.363 89.016L198.459 90.136L197.643 90.232C196.907 90.296 196.347 90.5307 195.963 90.936C195.579 91.3307 195.387 91.8747 195.387 92.568V97H194.075ZM202.356 97.144C201.748 97.144 201.172 97.0587 200.628 96.888C200.084 96.7173 199.636 96.4773 199.284 96.168L199.7 95.256C200.084 95.5653 200.505 95.7947 200.964 95.944C201.433 96.0827 201.908 96.152 202.388 96.152C202.996 96.152 203.454 96.04 203.764 95.816C204.073 95.592 204.228 95.288 204.228 94.904C204.228 94.6053 204.126 94.3707 203.924 94.2C203.721 94.0187 203.401 93.88 202.964 93.784L201.508 93.464C200.185 93.176 199.524 92.4933 199.524 91.416C199.524 90.712 199.801 90.1467 200.356 89.72C200.921 89.2933 201.657 89.08 202.564 89.08C203.097 89.08 203.604 89.1653 204.084 89.336C204.574 89.496 204.98 89.736 205.3 90.056L204.868 90.968C204.558 90.68 204.196 90.4613 203.78 90.312C203.374 90.152 202.969 90.072 202.564 90.072C201.966 90.072 201.513 90.1893 201.204 90.424C200.894 90.6587 200.74 90.968 200.74 91.352C200.74 91.9493 201.134 92.3333 201.924 92.504L203.38 92.808C204.062 92.9573 204.58 93.1973 204.932 93.528C205.284 93.848 205.46 94.2853 205.46 94.84C205.46 95.5547 205.177 96.12 204.612 96.536C204.046 96.9413 203.294 97.144 202.356 97.144Z",
    fill: "#4A4A68"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 45,
    y: 149,
    width: 198,
    height: 52,
    rx: 4,
    fill: "#D092DD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 140,
    width: 196,
    height: 50,
    rx: 3,
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 165C64 159.477 68.4772 155 74 155H94C99.5228 155 104 159.477 104 165C104 170.523 99.5228 175 94 175H74C68.4772 175 64 170.523 64 165Z",
    fill: "#4A4A68"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_di)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 165,
    r: 7,
    fill: "white"
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M115.392 170V158.72H119.856C121.072 158.72 122 159.013 122.64 159.6C123.291 160.187 123.616 161.024 123.616 162.112C123.616 163.189 123.291 164.027 122.64 164.624C122 165.211 121.072 165.504 119.856 165.504H116.704V170H115.392ZM116.704 164.4H119.696C121.445 164.4 122.32 163.637 122.32 162.112C122.32 160.576 121.445 159.808 119.696 159.808H116.704V164.4ZM125.185 170V162.224H126.449V163.616C126.865 162.677 127.718 162.16 129.009 162.064L129.473 162.016L129.569 163.136L128.753 163.232C128.017 163.296 127.457 163.531 127.073 163.936C126.689 164.331 126.497 164.875 126.497 165.568V170H125.185ZM134.329 170.144C133.103 170.144 132.132 169.787 131.417 169.072C130.703 168.347 130.345 167.365 130.345 166.128C130.345 165.328 130.505 164.624 130.825 164.016C131.145 163.397 131.583 162.923 132.137 162.592C132.703 162.251 133.353 162.08 134.089 162.08C135.145 162.08 135.972 162.421 136.569 163.104C137.167 163.776 137.465 164.704 137.465 165.888V166.384H131.609C131.652 167.269 131.908 167.947 132.377 168.416C132.847 168.875 133.497 169.104 134.329 169.104C134.799 169.104 135.247 169.035 135.673 168.896C136.1 168.747 136.505 168.507 136.889 168.176L137.337 169.088C136.985 169.419 136.537 169.68 135.993 169.872C135.449 170.053 134.895 170.144 134.329 170.144ZM134.121 163.04C133.385 163.04 132.804 163.269 132.377 163.728C131.951 164.187 131.7 164.789 131.625 165.536H136.345C136.313 164.747 136.105 164.133 135.721 163.696C135.348 163.259 134.815 163.04 134.121 163.04ZM139.449 166.272V165.2H143.929V166.272H139.449ZM151.206 170.144C150.161 170.144 149.249 169.909 148.47 169.44C147.702 168.96 147.105 168.288 146.678 167.424C146.262 166.56 146.054 165.536 146.054 164.352C146.054 163.168 146.262 162.144 146.678 161.28C147.094 160.416 147.686 159.749 148.454 159.28C149.233 158.811 150.15 158.576 151.206 158.576C152.273 158.576 153.19 158.811 153.958 159.28C154.737 159.749 155.334 160.416 155.75 161.28C156.177 162.133 156.39 163.152 156.39 164.336C156.39 165.52 156.177 166.549 155.75 167.424C155.323 168.288 154.721 168.96 153.942 169.44C153.174 169.909 152.262 170.144 151.206 170.144ZM151.206 168.976C152.411 168.976 153.345 168.571 154.006 167.76C154.667 166.949 154.998 165.813 154.998 164.352C154.998 162.891 154.667 161.76 154.006 160.96C153.345 160.149 152.411 159.744 151.206 159.744C150.022 159.744 149.099 160.149 148.438 160.96C147.777 161.76 147.446 162.891 147.446 164.352C147.446 165.803 147.777 166.939 148.438 167.76C149.099 168.571 150.022 168.976 151.206 168.976ZM158.56 170V162.224H159.824V163.616C160.24 162.677 161.093 162.16 162.384 162.064L162.848 162.016L162.944 163.136L162.128 163.232C161.392 163.296 160.832 163.531 160.448 163.936C160.064 164.331 159.872 164.875 159.872 165.568V170H158.56ZM167.16 170.144C166.467 170.144 165.859 169.979 165.336 169.648C164.824 169.317 164.424 168.853 164.136 168.256C163.859 167.648 163.72 166.933 163.72 166.112C163.72 165.28 163.859 164.565 164.136 163.968C164.424 163.36 164.824 162.896 165.336 162.576C165.859 162.245 166.467 162.08 167.16 162.08C167.768 162.08 168.302 162.213 168.76 162.48C169.23 162.747 169.576 163.115 169.8 163.584V158.72H171.096V170H169.832V168.576C169.608 169.067 169.262 169.451 168.792 169.728C168.323 170.005 167.779 170.144 167.16 170.144ZM167.432 169.104C168.158 169.104 168.739 168.848 169.176 168.336C169.614 167.813 169.832 167.072 169.832 166.112C169.832 165.141 169.614 164.4 169.176 163.888C168.739 163.376 168.158 163.12 167.432 163.12C166.696 163.12 166.11 163.376 165.672 163.888C165.246 164.4 165.032 165.141 165.032 166.112C165.032 167.072 165.246 167.813 165.672 168.336C166.11 168.848 166.696 169.104 167.432 169.104ZM177.033 170.144C175.806 170.144 174.835 169.787 174.121 169.072C173.406 168.347 173.049 167.365 173.049 166.128C173.049 165.328 173.209 164.624 173.529 164.016C173.849 163.397 174.286 162.923 174.841 162.592C175.406 162.251 176.057 162.08 176.793 162.08C177.849 162.08 178.675 162.421 179.273 163.104C179.87 163.776 180.169 164.704 180.169 165.888V166.384H174.312C174.355 167.269 174.611 167.947 175.081 168.416C175.55 168.875 176.201 169.104 177.033 169.104C177.502 169.104 177.95 169.035 178.377 168.896C178.803 168.747 179.209 168.507 179.593 168.176L180.041 169.088C179.689 169.419 179.241 169.68 178.697 169.872C178.153 170.053 177.598 170.144 177.033 170.144ZM176.825 163.04C176.089 163.04 175.507 163.269 175.081 163.728C174.654 164.187 174.403 164.789 174.329 165.536H179.049C179.017 164.747 178.809 164.133 178.425 163.696C178.051 163.259 177.518 163.04 176.825 163.04ZM182.044 170V162.224H183.308V163.616C183.724 162.677 184.577 162.16 185.868 162.064L186.332 162.016L186.428 163.136L185.612 163.232C184.876 163.296 184.316 163.531 183.932 163.936C183.548 164.331 183.356 164.875 183.356 165.568V170H182.044ZM190.324 170.144C189.716 170.144 189.14 170.059 188.596 169.888C188.052 169.717 187.604 169.477 187.252 169.168L187.668 168.256C188.052 168.565 188.474 168.795 188.932 168.944C189.402 169.083 189.876 169.152 190.356 169.152C190.964 169.152 191.423 169.04 191.732 168.816C192.042 168.592 192.196 168.288 192.196 167.904C192.196 167.605 192.095 167.371 191.892 167.2C191.69 167.019 191.37 166.88 190.932 166.784L189.476 166.464C188.154 166.176 187.492 165.493 187.492 164.416C187.492 163.712 187.77 163.147 188.324 162.72C188.89 162.293 189.626 162.08 190.532 162.08C191.066 162.08 191.572 162.165 192.052 162.336C192.543 162.496 192.948 162.736 193.268 163.056L192.836 163.968C192.527 163.68 192.164 163.461 191.748 163.312C191.343 163.152 190.938 163.072 190.532 163.072C189.935 163.072 189.482 163.189 189.172 163.424C188.863 163.659 188.708 163.968 188.708 164.352C188.708 164.949 189.103 165.333 189.892 165.504L191.348 165.808C192.031 165.957 192.548 166.197 192.9 166.528C193.252 166.848 193.428 167.285 193.428 167.84C193.428 168.555 193.146 169.12 192.58 169.536C192.015 169.941 191.263 170.144 190.324 170.144Z",
    fill: "#4A4A68"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 286,
    y: 108,
    width: 57.8006,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.407843 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 387,
    y: 8,
    width: 57.8006,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.407843 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 386,
    y: 82,
    width: 57.8006,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.407843 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 460,
    y: 90,
    width: 57.8006,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.407843 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 424,
    y: 189,
    width: 57.8006,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.407843 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i",
    x: 27,
    y: 82,
    width: 40,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.407843 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di",
    x: 48,
    y: 85,
    width: 18,
    height: 21.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.054902 0 0 0 0 0.172549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.054902 0 0 0 0 0.172549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i",
    x: 64,
    y: 155,
    width: 40,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.290196 0 0 0 0 0.407843 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_di",
    x: 85,
    y: 158,
    width: 18,
    height: 21.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.054902 0 0 0 0 0.172549 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.054902 0 0 0 0 0.172549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(306 125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(407 25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(406 99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(480 107)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(444 206)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreOrders);
export default __webpack_public_path__ + "static/media/pre-orders.ba01cf7722e2b305acb477417efeecd8.svg";
export { ForwardRef as ReactComponent };